import { GetAdminsMeta, GetAdminsPayload } from 'types/store/GetAdmins';
import { createAsyncReducer } from 'utils/Redux';

import { getAdminsActions } from '../actions';

export default createAsyncReducer<GetAdminsMeta, GetAdminsPayload>(getAdminsActions);
